import React, { useEffect } from 'react';

import { Paper } from '@material-ui/core';

import { useStyles } from '../../../../../Themable.hooks';

import { useMode } from '../../../../../../../state/ui/customerService/bottomGrid/index.hooks';
import {
    enterPreviewMode,
    resetMode,
} from '../../../../../../..//state/ui/customerService/bottomGrid';

import { useToolkitDispatch } from '../../../../../../../hooks';

import TaskPreview from '../TaskPreview';
import ClientEditForm from '../../ClientsAndLocations/ClientEditForm';
import LocationEditForm from '../../ClientsAndLocations/LocationEditForm';
import LocationAddForm from '../../ClientsAndLocations/LocationAddForm';
import { closePane } from '../../../../../../../state/ui/customerService/pane/tasksPane';
import {
    useTask,
    useTaskId,
    useTaskReport,
} from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';
import {
    useSelectedClient,
    useSelectedClientId,
    useSelectedLocation,
    useSelectedLocationId,
} from '../../../../../../../state/ui/customerService/clientsAndLocations/index.hooks';
import { useSelectedPane } from '../../../../../../../state/ui/customerService/pane/tasksPane/index.hooks';
import LocationPane from '../LocationPane';
import ContractPane from '../ContractPane';
import ContractItemPane from '../ContractItemPane';
import ClientPane from '../ClientPane';
import { errorMessageHandler } from '../../../../../../../helpers/errorMessageHandler';
import { useSnackbar } from 'notistack';
import {
    fetchClient,
    fetchLocation,
    resetClient,
    resetLocation,
} from '../../../../../../../state/ui/customerService/clientsAndLocations';
import { fetchTask } from '../../../../../../../state/ui/customerService/bottomGrid/tasks';
import { SelectPane } from './SelectPane';

const TasksPane = () => {
    const classes = useStyles();

    const toolkitDispatch = useToolkitDispatch();

    const mode = useMode();

    const selectedTaskPane = useSelectedPane();
    const client = useSelectedClient();
    const location = useSelectedLocation();
    const task = useTask();
    const taskId = useTaskId();
    const taskReport = useTaskReport();
    const contractItem = task?.contractItem;
    const contract = task?.contractItem?.contract;
    const { enqueueSnackbar } = useSnackbar();

    const locationId = useSelectedLocationId();
    const clientId = useSelectedClientId();

    const handleModificationClose = () => {
        toolkitDispatch(enterPreviewMode());
    };

    const handlePreviewClose = () => {
        toolkitDispatch(resetMode());
        toolkitDispatch(closePane());
    };

    useEffect(() => {
        locationId
            ? toolkitDispatch(fetchLocation(locationId))
                  .unwrap()
                  .catch((error) => {
                      const message = errorMessageHandler(error.status)();
                      enqueueSnackbar(message, {
                          variant: 'error',
                      });
                  })
            : toolkitDispatch(resetLocation());
    }, [locationId]);
    useEffect(() => {
        clientId
            ? toolkitDispatch(fetchClient(clientId))
            : toolkitDispatch(resetClient());
    }, [clientId]);

    useEffect(() => {
        taskId && toolkitDispatch(fetchTask(taskId));
    }, [taskId]);

    const renderPane = () => {
        switch (mode) {
            case 'create':
                return <></>;
            case 'preview':
                switch (selectedTaskPane) {
                    case 'Task':
                        return (
                            <TaskPreview
                                task={task}
                                taskReport={taskReport}
                                handleClose={handlePreviewClose}
                                titleComponent={
                                    <SelectPane
                                        contract={contract}
                                        contractItem={contractItem}
                                    />
                                }
                            />
                        );
                    case 'Contract':
                        return (
                            <ContractPane
                                contract={contract}
                                handleClose={handlePreviewClose}
                                titleComponent={
                                    <SelectPane
                                        contract={contract}
                                        contractItem={contractItem}
                                    />
                                }
                            />
                        );
                    case 'ContractItem':
                        return (
                            <ContractItemPane
                                contracItem={contractItem}
                                handleClose={handlePreviewClose}
                                titleComponent={
                                    <SelectPane
                                        contract={contract}
                                        contractItem={contractItem}
                                    />
                                }
                            />
                        );
                    case 'Client':
                        return (
                            <ClientPane
                                client={client}
                                handleClose={handlePreviewClose}
                                titleComponent={
                                    <SelectPane
                                        contract={contract}
                                        contractItem={contractItem}
                                    />
                                }
                            />
                        );
                    case 'Location':
                        return (
                            <LocationPane
                                location={location}
                                handleClose={handlePreviewClose}
                                titleComponent={
                                    <SelectPane
                                        contract={contract}
                                        contractItem={contractItem}
                                    />
                                }
                            />
                        );
                    default:
                        return;
                }
            case 'editClient':
                return <ClientEditForm handleClose={handleModificationClose} />;
            case 'editLocation':
                return (
                    <LocationEditForm handleClose={handleModificationClose} />
                );
            case 'addLocation':
                return (
                    <LocationAddForm handleClose={handleModificationClose} />
                );
            default:
                return;
        }
    };
    return (
        <Paper className={classes.formPane}>
            <div className={classes.wrapper}>{renderPane()}</div>
        </Paper>
    );
};

export default TasksPane;
